import { create } from 'zustand';
import { TempAlertPosition, TempAlertType } from '../../enum/EnumRepository';
import { getTempAlertMessage } from '../../constants/tempAlertMessages';


export interface TempAlert {
  type: TempAlertType;
  position: TempAlertPosition;
  content: string;
  duration: number;
  callBack?: () => void;
  onClick?: () => void;
}

interface tempAlertState {
  tempAlert: TempAlert | null;
  setTempAlert: (tempAlert: TempAlert) => void;
  setUpdatedTempAlert: () => void;
  setDeletedTempAlert: () => void;
  setUnauthorizedAccessTempAlert: () => void;
  setSubscriptionSuccessTempAlert: () => void;
  clearTempAlert: () => void;
}

export const useTempAlertStore = create<tempAlertState>((set) => ({
  tempAlert: null,
  setTempAlert: (tempAlert: TempAlert) => set({ tempAlert }),
  setUpdatedTempAlert: () => set({
    tempAlert: {
      type: TempAlertType.UPDATED,
      position: TempAlertPosition.RB,
      content: getTempAlertMessage('UPDATED_SUCCESSFULLY'),
      duration: 2500
    }
  }),
  setDeletedTempAlert: () => set({
    tempAlert: {
      type: TempAlertType.UPDATED,
      position: TempAlertPosition.RB,
      content: getTempAlertMessage('DELETED_SUCCESSFULLY'),
      duration: 2000
    }
  }),
  setUnauthorizedAccessTempAlert: () => set({
    tempAlert: {
      type: TempAlertType.UNAUTHORIZED_ACCESS,
      position: TempAlertPosition.RT,
      content: getTempAlertMessage('UNAUTHORIZED_ACCESS'),
      duration: 2000
    }
  }),
  setSubscriptionSuccessTempAlert: () => set({
    tempAlert: {
      type: TempAlertType.UPDATED,
      position: TempAlertPosition.RB,
      content: getTempAlertMessage('SUBSCRIPTION_SUCCESS'),
      duration: 3000
    }
  }),
  clearTempAlert: () => set({ tempAlert: null })
}));
